import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { map, take, takeUntil } from 'rxjs/operators';
import { combineLatest, of, ReplaySubject } from 'rxjs';
import { IDefaultPerspectiveInfo, IPerspectiveDashboard } from 'app/services/graphqlApi.service';
import { PanelService } from 'app/shared/panels/chart/Services/panel.service';
import { DashboardSidebarService } from './services/dashboard-sidebar.service';
import { IPerspective, IPerspectiveAggregation, Perspective } from 'app/perspectives/interfaces/interfaces';
import { IGroupAssetsTableRow } from 'app/assets/interfaces/interfaces';
import { TreeNode } from 'app/shared/tree';
import { EEntityTypes } from 'app/shared/enums';
import { TREE_NODE_TYPE } from 'app/perspectives/constants';

@Component({
  selector: 'app-dashboard-sidebar',
  templateUrl: './dashboard-sidebar.component.html',
  styleUrls: ['./dashboard-sidebar.component.scss']
})

export class DashboardSidebarComponent implements OnInit {
  readonly destroyed = new ReplaySubject(1);
  @Output() selectedNodePath = new EventEmitter();
  @Input() set selectedBreadCrumb(selectedBreadCrumItem: TreeNode) {
    console.log('selectedBreadCrumItem: ', selectedBreadCrumItem);
    if (selectedBreadCrumItem) {
      if (selectedBreadCrumItem?.type !== 'dashboardName') {
        this.selectedNode = selectedBreadCrumItem;
        this.selectedNodeChange(selectedBreadCrumItem);
      }
    }
  }

  perspective = new FormControl(null);
  fileteredPerspective$ = of([]);
  selectedPerspective: Perspective | null = null;
  dataSource: TreeNode[] = [];
  breadCrumbs: TreeNode[] = [];
  perspectiveDashboards: IPerspectiveDashboard[] = [];
  dashboards: IPerspectiveDashboard[];
  perspectiveAggregations: IPerspectiveAggregation[];
  aggregations: IPerspectiveAggregation[];
  treeNodeTypes = TREE_NODE_TYPE;
  selectedNode: TreeNode | null = null;
  defaultPerspective: IDefaultPerspectiveInfo;
  perspectiveGroup = new FormGroup({ perspective: this.perspective });

  constructor(private readonly dashboardSidebarService: DashboardSidebarService, private readonly panelService: PanelService, private readonly router: Router) { }

  ngOnInit(): void {
    // get all perspectives
    this.dashboardSidebarService.getAllPerspectives().pipe(take(1)).subscribe((allPerspectives: IPerspective[]) => {
      const perspectiveIds: string[] = allPerspectives.map(perspective => perspective.id);
      if (perspectiveIds.length) {
        this.dashboardSidebarService.getPerspectivesDetailsByIds(perspectiveIds).pipe(take(1)).subscribe((perspectives: Perspective[]) => {
          this.dashboardSidebarService.perspectives.next(perspectives);

          // setting default perspective
          const defaultPerspective: IPerspective = allPerspectives.find(perspective => perspective.isDefault);
          if (defaultPerspective) {
            const perspective: Perspective = perspectives?.find((perspective: Perspective) => perspective.id === defaultPerspective.id);
            this.dashboardSidebarService._defaultPerspectives.next({ userName: '', perspectiveId: perspective.id });
            this.perspective.setValue(perspective.name);
            this.perspectiveSelected(perspective.name);
          } else if (perspectives.length === 1) {
            // this.dashboardSidebarService._defaultPerspectives.next({ userName: '', perspectiveId: perspectives[0].id });
            this.perspective.setValue(perspectives[0].name);
            this.perspectiveSelected(perspectives[0].name);
            this.setDefaultPerspective(perspectives[0].id);
          } else {
            (perspectives || []).forEach((perspective: Perspective) => {
              perspective.isDefaultPerspective = false;
            });

            this.dashboardSidebarService._allPerspectives.next(perspectives);
          }
        });
      }

      this.fileteredPerspective$ = combineLatest([
        this.dashboardSidebarService.perspectives$,
        this.dashboardSidebarService.defaultPerspectives$,
      ]).pipe(map(([perspectives, defaultPerspective]) => {
        // setting default perspective to array
        perspectives?.forEach((perspective: Perspective) => {
          if (perspective.id === defaultPerspective?.perspectiveId || (perspectives.length === 1)) {
            perspective.isDefaultPerspective = true;
          } else {
            perspective.isDefaultPerspective = false;
          }
        });

        this.selectedPerspective = null;
        this.dashboardSidebarService._allPerspectives.next(perspectives);
        return perspectives;
      }));
    });

    // selected perspective
    this.dashboardSidebarService.selectedPerspective$.pipe(takeUntil(this.destroyed))
      .subscribe((perspective: Perspective) => {
        if (perspective) {
          this.selectedPerspective = perspective;
          console.log('this.selectedPerspective: 77', this.selectedPerspective);
          this.dataSource = this.dashboardSidebarService.buildTreeWithLeafNode(perspective);
          this.perspectiveAggregations = this.selectedPerspective.perspectiveAggregations?.length ? this.selectedPerspective.perspectiveAggregations : [];
          this.dashboardSidebarService._perspectiveAggregations.next(this.perspectiveAggregations);
          console.log('this.perspectiveAggregations: ', this.perspectiveAggregations);
          this.perspectiveDashboards = this.selectedPerspective.perspectiveDashboards?.length ? this.selectedPerspective.perspectiveDashboards : [];
          const defaultPerspective: IDefaultPerspectiveInfo = this.dashboardSidebarService._defaultPerspectives.getValue();
          console.log('defaultPerspective: 77', defaultPerspective);
          if (this.dataSource[0]?.data?.pGroupValue?.type === TREE_NODE_TYPE.root && defaultPerspective?.perspectiveId) {
            if (this.dataSource[0].data.pGroupValue.perspectiveId === defaultPerspective?.perspectiveId) {
              this.dataSource[0].data.pGroupValue.isDefault = true;
            }

            // to show root's default dashboard
            this.selectedNodeChange(this.dataSource[0]);
          }

          // to high-light/select pre-selected node
          this.selectedNode = this.dataSource[0];
          this.findSelectedBreadCrumbItem();
          // javascript style change
          setTimeout(() => {
            const assetTextElement = document.querySelector(".asset-text"); //div in your original code
            const parentElement = assetTextElement?.closest("ul");
            if(parentElement?.classList){
              parentElement.classList.add("asset-text-section");
            }
          }, 0);
        }
      });

    // on cell click of asset and group table
    this.panelService.rowClickAssetGroupTable$.pipe(takeUntil(this.destroyed)).subscribe((selectedRowDetail: IGroupAssetsTableRow) => {
      if (selectedRowDetail?.groupId) {
        this.dataSource.filter((node: TreeNode) => {
          node.children.filter((child: TreeNode) => {
            // check in first level
            if (child?.data?.pGroupValue?.value === selectedRowDetail?.groupName && child?.data?.pGroupValue?.id === selectedRowDetail?.groupId) {
              this.selectedNode = child;
              this.selectedNodeChange(child);
              // check in sublevels
            } else if (child?.children?.length) {
              this.subLevelGroupCheck(child.children, selectedRowDetail);
            }
          });
        });
      } else if (selectedRowDetail?.assetId) {
        this.dataSource.filter((node: TreeNode) => {
          node.children.filter((child: TreeNode) => {
            if (child?.data?.pGroupValue?.value === selectedRowDetail?.assetName) {
              this.selectedNode = child;
              this.selectedNodeChange(child);
            } else if (child?.children?.length) {
              this.subLevelGroupCheck(child.children, selectedRowDetail);
            }
          });
        });
      }
    });

    // to set perspective as default
    this.dashboardSidebarService.setPerspectiveAsDefault$.pipe(takeUntil(this.destroyed)).subscribe((perspectiveId: string) => {
      if (perspectiveId) {
        this.setDefaultPerspective(perspectiveId);
        this.dashboardSidebarService._setPerspectiveAsDefault.next('');
      }
    });

  }

  get isDashboardPage() { return this.router.url.includes(EEntityTypes.DASHBOARD) }

  //#region subLevelGroupCheck, selectedNodeChange, and perspectiveSelected methods

  /**
   * after cell click of asset and group table
   * finding group and assets in sublevels
   * @param children node children
   * @param selectedRowDetail selected Row detail
   */
  subLevelGroupCheck(children: TreeNode[], selectedRowDetail: IGroupAssetsTableRow) {
    children.filter((child: TreeNode, index: number) => {
      if (child?.data?.pGroupValue?.value === selectedRowDetail?.assetName) {
        this.selectedNode = child;
        this.selectedNodeChange(child);
      } else if (child?.data?.pGroupValue?.value === selectedRowDetail?.groupName && child?.data?.pGroupValue?.id === selectedRowDetail?.groupId) {
        this.selectedNode = child;
        this.selectedNodeChange(child);
      } else if (children[index].children?.length) {
        this.subLevelGroupCheck(children[index].children, selectedRowDetail);
      }
    });
  }

  /**
   * selected node change
   * @param node node
   */
  selectedNodeChange(node: TreeNode) {
    console.log('node:123 ', node);
    this.dashboards = [];
    this.aggregations = [];
    if (node.data.pGroupValue.type === TREE_NODE_TYPE.leaf) {
      this.dashboardSidebarService._selectedAsset.next(node.data.pGroupValue || null);
    } else if (this.perspectiveDashboards.length) {
      this.dashboards = this.perspectiveDashboards.filter(dashboard => dashboard.perspectiveGroupId === node.data?.pGroupValue?.id);
      console.log('this.dashboards123: ', this.dashboards);
      this.aggregations = this.perspectiveAggregations.filter(aggregation => aggregation.perspectiveGroupId === node.data?.pGroupValue?.id);
      this.dashboardSidebarService._selectedGroupAggregations.next(this.aggregations);
      this.dashboardSidebarService._selectedGroupDashboards.next(this.dashboards);
    } else {
      this.dashboardSidebarService._selectedGroupAggregations.next([]);
      this.dashboardSidebarService._selectedGroupDashboards.next([]);
      this.dashboardSidebarService._selectedAsset.next(null);
    }

    this.findSelectedBreadCrumbItem(node);
  }

  /**
   * perspective selected
   * @param perspectiveName perspective name
   */
  perspectiveSelected(perspectiveName: string) {
    let selectedPerspective: any;
    this.fileteredPerspective$.pipe(takeUntil(this.destroyed)).subscribe(perspectiveList => {
      selectedPerspective = perspectiveList?.find(p => p.name === perspectiveName);
    });

    if (!!selectedPerspective) {
      this.dashboardSidebarService.selectedPerspective.next(null); // to avoid double perspective's default dashboard calls on perspective change
      this.dashboardSidebarService.setPerspectiveById(selectedPerspective.id);
      this.dashboardSidebarService._selectedGroupDashboards.next([]);
    }
  }

  //#endregion

  //#region setDefaultPerspective and getDefaultPerspective methods

  /**
   * set default perspective bu perspective id
   * @param perspectiveId perspective id
   */
  setDefaultPerspective(perspectiveId: string) {
    if (perspectiveId) {
      this.dashboardSidebarService.setDefaultPerspectiveById(perspectiveId).pipe(take(1)).subscribe(response => {
        this.getDefaultPerspective();
      });
    }
  }

  /**
   * get default perspective against user name
   * @param isOnload flag to detech first load
   */
  getDefaultPerspective(isOnload?: boolean) {
    const userName: string = JSON.parse(localStorage.getItem('Token'))?.userName;
    if (userName) {
      this.dashboardSidebarService.getDefaultPerspectiveByUserName(userName).pipe(take(1)).subscribe((defaultPerspectiveResponse: any[]) => {
        console.log('default Perspective :>>', defaultPerspectiveResponse);
        if (defaultPerspectiveResponse.length) {
          this.dashboardSidebarService._defaultPerspectives.next({ userName: defaultPerspectiveResponse[0].user_name, perspectiveId: defaultPerspectiveResponse[0].perspective_id });
          this.dashboardSidebarService.perspectives$.pipe(takeUntil(this.destroyed)).subscribe((perspectives: Perspective[]) => {
            // console.log('perspectives: ', perspectives);
            if (isOnload && perspectives.length) {
              perspectives.forEach((perspective: Perspective) => {
                if (perspective.isDefaultPerspective) {
                  this.perspective.setValue(perspective.name);
                  this.perspectiveSelected(perspective.name);
                }
              })
            } else {
              const allPerspectives: Perspective[] = this.dashboardSidebarService._allPerspectives.getValue() || [];
              allPerspectives.forEach(p => {
                p.isDefaultPerspective = (p.id === defaultPerspectiveResponse[0].perspective_id) ? true : false;
              });

              this.dashboardSidebarService._allPerspectives.next(allPerspectives);
            }
          });
        }
      });
    }
  }

  //#endregion

  //#region findSelectedBreadCrumbItem, subLevelCheckSelectedNode, buildBreadCrumbs and checkParentForBreadCrumbs methods

  /**
   * find selected breadcrumb item
   * @param selectedNode selected node
   */
  findSelectedBreadCrumbItem(selectedNode?: TreeNode) {
    this.dataSource?.find((node: TreeNode) => {
      if (node.data?.pGroupValue?.value === selectedNode?.data?.pGroupValue?.value) {
        this.breadCrumbs = [];
        this.breadCrumbs.push(node);
      }

      if (node.children.length) {
        this.subLevelCheckSelectedNode(node.children, selectedNode);
      }
    });

    this.selectedNodePath.emit([...this.breadCrumbs]);
  }

  /**
   * check in sublevels for breadcrumbs
   * @param children node children
   * @param selectedNode selected node
   */
  subLevelCheckSelectedNode(children: TreeNode[], selectedNode: TreeNode) {
    children.filter((child: TreeNode, index: number) => {
      if (child?.data?.pGroupValue?.value == selectedNode?.data?.pGroupValue?.value) {
        this.breadCrumbs = [];
        this.buildBreadCrumbs(child);
        if (child.children.length) {
          this.subLevelCheckSelectedNode(child.children, selectedNode);
        }
      } else if (children[index].children?.length) {
        this.subLevelCheckSelectedNode(children[index].children, selectedNode);
      }
    });
  }

  /**
   * build breadcrumb items
   * @param selectedNode selected node
   */
  buildBreadCrumbs(selectedNode: TreeNode) {
    this.breadCrumbs.push(selectedNode);
    if (selectedNode.parent) {
      this.checkParentForBreadCrumbs(selectedNode.parent);
    }
  }

  /**
   * check parent for breadcrumbs items
   * @param node node
   */
  checkParentForBreadCrumbs(node: TreeNode) {
    this.breadCrumbs.push(node);
    if (node.parent) {
      this.checkParentForBreadCrumbs(node.parent);
    }
  }

  //#endregion

  ngOnDestroy() {
    this.dashboardSidebarService.perspectives.next(null);
    this.dashboardSidebarService._defaultPerspectives.next(null);
    this.dashboardSidebarService.selectedPerspective.next(null);
    this.destroyed.next();
    this.destroyed.complete();
  }

}